import "./Title.scss";

const Title = ({ text }) => {
  return <p className="title-comp">{text}</p>;
};

export default Title;
